export default __webpack_public_path__ + "ab765f5f3981d4163ce5a717e49534ef.png";